(() => {
  const cartContainer = document.querySelector(".cart-container");

  function updateCart(productId, quantity, callback) {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [productId]: quantity } }),
    })
      .then(callback)
      .catch((err) => console.error("Error:", err));
  }

  function closeCart() {
    cartContainer.classList.remove("opacity-100");
    cartContainer.classList.add("opacity-0", "pointer-events-none");
    document.body.style.position = "";
    document.body.setAttribute("data-state-cart", "closed");
  }

  function getQuantityDisplay(btn) {
    return btn.parentElement.querySelector(".quantity-current");
  }

  function onSectionDeselect(e) {
    if (e.target.id === "shopify-section-cart") closeCart();
  }

  // ✅ Delegated listener — works even when close button is injected dynamically
  cartContainer.addEventListener("click", function (e) {
    if (e.target.closest(".cart-close")) closeCart();
  });

  document.removeEventListener("shopify:section:deselect", onSectionDeselect);
  document.addEventListener("shopify:section:deselect", onSectionDeselect);

  cartContainer.querySelectorAll(".quantity-change").forEach((btn) => {
    btn.onclick = () => {
      getQuantityDisplay(btn).classList.add("opacity-0");
      const productId = parseInt(btn.getAttribute("data-product-id"));
      const newQty = parseInt(btn.getAttribute("data-new-quantity"));

      updateCart(productId, newQty, (res) => {
        getQuantityDisplay(btn).innerHTML = newQty;
        getQuantityDisplay(btn).classList.remove("opacity-0");
        btn.parentElement.querySelector(".quantity-down").setAttribute("data-new-quantity", newQty - 1);
        btn.parentElement.querySelector(".quantity-up").setAttribute("data-new-quantity", newQty + 1);
        return res.json();
      });
    };
  });

  cartContainer.querySelectorAll(".mobile-quantity-input").forEach((input) => {
    input.addEventListener("change", (e) => {
      updateCart(e.target.getAttribute("data-product-id"), e.target.value, () => location.reload());
    });
  });
})();